import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from 'src/app/services/services.index';
import Swal from 'sweetalert2';
import { swalWarning } from '../shared/config/swalCommon';
import { Petition } from '../interfaces/petition';

@Injectable({
  providedIn: 'root'
})
export class StepsGuard implements CanActivate {

  url: string;
  selPetition: Petition;

  constructor( private userService: UserService ) { }

  canActivate(routeSnapshot: ActivatedRouteSnapshot)
  {
    this.selPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
    const hasRole = ['Cliente', 'Codeudor', 'Asesor integral'].some(r=> this.userService.user.role.includes(r));
    const steps = routeSnapshot.data['steps'] as Number[];

    if(hasRole && steps.includes(this.selPetition?.processId))
      return true;
    else {
        Swal.fire(swalWarning('¡Acceso denegado!',`No tiene permisos para acceder`));
        return false;
    }
  }
}
